import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import statsService from "../../../services/statsService";
import { listEventPhotoKeys } from "../../../helpers/myPhotos";
import { RevCard, RevKvRow } from "../../../components/ds";

const EventSharedSummary = ({ eventId, user }) => {
    const { t, i18n } = useTranslation();
    const [totalPhotos, setTotalPhotos] = useState(null);
    const [myUploads, setMyUploads] = useState(null);

    useEffect(() => {
        let alive = true;
        if (!eventId) return undefined;

        statsService.getNumberOfPhotos(eventId).then((response) => {
            if (alive) setTotalPhotos(Number(response?.data?.Data));
        }).catch((error) => {
            console.error("Error fetching number of photos:", error);
        });

        const countMyUploads = async () => {
            try {
                const { mine } = await listEventPhotoKeys(eventId, user.id);
                if (alive) setMyUploads(mine.length);
            } catch (error) {
                console.error("Error listing uploaded photos:", error);
            }
        };
        if (user?.id) countMyUploads();

        return () => {
            alive = false;
        };
        // eslint-disable-next-line
    }, [eventId, user?.id]);

    const numberFormatter = new Intl.NumberFormat(i18n.language);
    const fmt = (value) => (value == null || Number.isNaN(value) ? "—" : numberFormatter.format(value));

    return (
        <div>
            <div className="rev-cols rev-cols--flush">
                <div className="rev-cols__main">
                    <RevCard title={t('eventSharedSummary.uploaded.title')}>
                        <RevKvRow ruled num k={t('eventSharedSummary.uploaded.total')} v={fmt(totalPhotos)} />
                        <RevKvRow ruled num k={t('eventSharedSummary.uploaded.mine')} v={fmt(myUploads)} />
                        <span className="rev-help">{t('eventSharedSummary.uploaded.note')}</span>
                    </RevCard>
                </div>

                <div className="rev-cols__aside">
                    <RevCard title={t('eventSharedSummary.access.title')}>
                        <RevKvRow ruled tone="brand" k={t('eventSharedSummary.access.upload')} v={t('eventSharedWith.permissions.yes')} />
                        <RevKvRow ruled tone="brand" k={t('eventSharedSummary.access.manageOwn')} v={t('eventSharedWith.permissions.yes')} />
                        <RevKvRow ruled tone="brand" k={t('eventSharedSummary.access.summary')} v={t('eventSharedWith.permissions.yes')} />
                        <RevKvRow ruled tone="no" k={t('eventSharedSummary.access.manageOthers')} v={t('eventSharedWith.permissions.no')} />
                        <RevKvRow ruled tone="no" k={t('eventSharedSummary.access.pricing')} v={t('eventSharedWith.permissions.no')} />
                        <RevKvRow ruled tone="no" k={t('eventSharedSummary.access.credits')} v={t('eventSharedWith.permissions.no')} />
                        <span className="rev-help">{t('eventSharedSummary.access.note')}</span>
                    </RevCard>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    user: state.usersReducer.user,
});

export default connect(mapStateToProps)(EventSharedSummary);
